define.alias("shared/components/shared/wizard/previous-button", "calendar/components/shared/wizard/previous-button");